import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import icon from './boardImages/food.png';
import listicle from './boardImages/note.png';
import freeform from './boardImages/forms.png';
// import trail from './boardImages/route.png';
// import event from './boardImages/calendar-icon.png';
// import links from 'utils/links';
// import { Link } from 'react-router-dom';

const styles = {
  card: {
    // maxWidth: 345,
    margin: '5px',
    marginTop: '10px',
  },
  media: {
    // objectFit: 'cover',
    width: '25%',
    height: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    pointer: 'hand',
    marginTop: '20px',
  },
  boardContainer: {
    backgroundColor: '#7d23c18c',
    // display:'flex',
    // flexDirection: 'row'
  },
  header: {
    color: '#fff',
  },
};

const boards = [
  {
    image: freeform,
    title: 'Story',
    link: '/story/add',
  },
  {
    image: icon,
    title: 'Eatery',
    link: '/eatery/add',
  },
  {
    image: listicle,
    title: 'Listicle',
    link: '/listicle/add',
  },
  
  // {
  //   image: trail,
  //   title: 'Trail',
  //   link: '/add/listicle',
  // },
  // {
  //   image: event,
  //   title: 'Event',
  //   link: '/add/listicle',
  // },
];

class AddNew extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        {' '}
        {boards.map((board, index) => {
          return (
            <Card key={'eatery' + index} className={classes.card}>
              <a href={board.link} target="_blank" rel="noopener noreferrer">
                <CardMedia
                  component="img"
                  alt="eatery"
                  className={classes.media}
                  // height="140"
                  image={board.image}
                  title="Contemplative Reptile"
                />
              </a>{' '}
              <CardContent align="center">
                <a href={board.link} target="_blank" rel="noopener noreferrer">
                  <Typography gutterBottom variant="h5" component="h2">
                    {' '}
                    {board.title}{' '}
                  </Typography>{' '}
                </a>{' '}
              </CardContent>{' '}
            </Card>
          );
        })}{' '}
      </div>
    );
  }
}

AddNew.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddNew);
